import React, { useState, useRef } from "react";

export default function LogoUploader({ currentImage, onImageChange }) {
    const [image, setImage] = useState(currentImage); // default image path
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef(null);


    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const mimeToExt = {
            "image/jpeg": "jpg",
            "image/png": "png",
            "image/gif": "gif",
            "image/webp": "webp",
        };
        const ext = mimeToExt[file.type] || "bin";
        const filename = `logo.${ext}`;

        // Prepare FormData for upload
        const formData = new FormData();
        formData.append("image", file, filename);

        try {
            setUploading(true);
            const response = await fetch("/image/upload/logo", {
                method: "POST",
                body: formData,
                headers: {
                    'X-CSRF-TOKEN': JSON.parse(document.body.getAttribute("hx-headers") || "{}")['X-CSRF-TOKEN']
                }
            });

            if (!response.ok) throw new Error("Upload failed");

            const results = await response.json();

            if (!results || results.success !== 1 || !results.file) {
                alert(results?.error || "Kunde inte ladda upp logotypen. Försök igen senare.");
                return;
            }

            setImage(results.file.url);
            onImageChange(results.file.url);

            console.debug("Upload successful");
        } catch (error) {
            console.error("Upload error:", error);
            alert("Kunde inte ladda upp logotypen. Försök igen senare.");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            {image &&
                <img
                    src={image}
                    alt="Logo"
                    className="logotype"
                />
            }

            <label>
                <button
                    type="button"
                    onClick={handleButtonClick}
                    disabled={uploading}
                    className="btn btn-primary"
                >
                    {uploading ? "Laddar upp..." : "Välj logotyp"}
                </button>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    className="hidden"
                    style={{display: "none"}}
                    onChange={handleImageChange}
                />
            </label>
        </div>
    );
}